export const displayChannelConstants = {
  DISPLAY_CHANNEL_LIST_REQUEST: 'DISPLAY_CHANNEL_LIST_REQUEST',
  DISPLAY_CHANNEL_LIST_SUCCESS: 'DISPLAY_CHANNEL_LIST_SUCCESS',
  DISPLAY_CHANNEL_LIST_FAILURE: 'DISPLAY_CHANNEL_LIST_FAILURE',
  DISPLAY_CHANNEL_LIST_CHANGED: 'DISPLAY_CHANNEL_LIST_CHANGED',
  DISPLAY_CHANNEL_LIST_PAGINATION: 'DISPLAY_CHANNEL_LIST_PAGINATION',

  DISPLAY_CHANNEL_LOAD_REQUEST: 'DISPLAY_CHANNEL_LOAD_REQUEST',
  DISPLAY_CHANNEL_LOAD_SUCCESS: 'DISPLAY_CHANNEL_LOAD_SUCCESS',
  DISPLAY_CHANNEL_LOAD_FAILURE: 'DISPLAY_CHANNEL_LOAD_FAILURE',

  DISPLAY_CHANNEL_SAVE_REQUEST: 'DISPLAY_CHANNEL_SAVE_REQUEST',
  DISPLAY_CHANNEL_SAVE_SUCCESS: 'DISPLAY_CHANNEL_SAVE_SUCCESS',
  DISPLAY_CHANNEL_SAVE_FAILURE: 'DISPLAY_CHANNEL_SAVE_FAILURE',
  DISPLAY_CHANNEL_DONE_SUCCESS: 'DISPLAY_CHANNEL_DONE_SUCCESS',
};
